import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { GraphqlErrorMessage } from "../../../components/ErrorMessage";
import { Loading } from "../../../components/LoadingFork";
import { withInstallation } from "../../../components/InstallationContext";
import { T } from "../constants";
import Panel from "../components/Panel";
import Toast from "../components/Toast";
import VipPageShell, { HeaderCount } from "../vip/components/VipPageShell";
import AddShiftForm from "./components/AddShiftForm";
import ShiftRow from "./components/ShiftRow";
import useRunnerShifts from "./useRunnerShifts";

const useStyles = makeStyles({
  blurb: { maxWidth: 760, marginBottom: 24, fontSize: 14, color: T.mutedFg },
  grid: {
    display: "grid",
    gap: 24,
    gridTemplateColumns: "1fr 360px",
    alignItems: "start",
    "@media (max-width: 1100px)": { gridTemplateColumns: "1fr" },
  },
  panelHead: { borderBottom: `1px solid ${T.borderSoft}`, background: T.surface, padding: "12px 20px" },
  panelTitle: { margin: 0, fontSize: 16, fontWeight: 600, color: T.fg },
  panelSub: { margin: "2px 0 0", fontSize: 12, color: T.mutedFg },
  list: { listStyle: "none", margin: 0, padding: 0 },
  empty: { padding: 20, color: T.mutedFg, fontSize: 14 },
  error: { marginBottom: 24 },
});

function RunnerShifts({ installation }) {
  const s = useStyles();
  const installationId = installation?.id;
  const {
    shifts,
    loading,
    error,
    mutationError,
    mutationInFlight,
    toast,
    create,
    update,
    remove,
  } = useRunnerShifts(installationId);

  if (loading) return <Loading />;
  if (error) return <GraphqlErrorMessage error={error} />;

  return (
    <VipPageShell
      eyebrow="Admin - Configuration"
      title="Runner shifts"
      right={<HeaderCount label="Shifts" value={shifts.length} />}
    >
      <p className={s.blurb}>
        Configure the shifts runners work at this hotel. Times are local to the hotel.
      </p>

      {mutationError && <GraphqlErrorMessage className={s.error} error={mutationError} />}

      <div className={s.grid}>
        <Panel>
          <div className={s.panelHead}>
            <h2 className={s.panelTitle}>Shifts</h2>
            <p className={s.panelSub}>Edit a row, save it, or remove shifts that are no longer used.</p>
          </div>
          {shifts.length ? (
            <ul className={s.list}>
              {shifts.map((shift) => (
                <ShiftRow
                  key={shift.id}
                  shift={shift}
                  disabled={mutationInFlight}
                  onDelete={remove}
                  onSave={update}
                />
              ))}
            </ul>
          ) : (
            <div className={s.empty}>No shifts have been configured for this installation.</div>
          )}
        </Panel>

        <Panel>
          <AddShiftForm disabled={mutationInFlight || !installationId} onAdd={create} />
        </Panel>
      </div>

      {toast && <Toast>{toast}</Toast>}
    </VipPageShell>
  );
}

export default withInstallation(RunnerShifts);
